import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '@wit-support/ui';
import { FieldShell } from './field-shell.js';
import { isIntNumber } from '../lib/walk-schema.js';
import { useDraftValue } from '../lib/use-draft-value.js';
/** Текст поля для значения, пришедшего из формы. `null`/`undefined` — пусто. */
function toText(value) {
    return value === undefined || value === null ? '' : String(value);
}
/** Значение, которое кладём в форму для набранного текста (пусто → `undefined`). */
function toValue(raw) {
    if (raw === '')
        return undefined;
    const n = Number(raw);
    return Number.isNaN(n) ? raw : n;
}
export function NumberWidget(props) {
    const { field, fieldState, meta, schema, label, description, hint, readonly, disabled } = props;
    const step = isIntNumber(schema) ? 1 : 'any';
    // Черновик набранного текста — см. `useDraftValue` (общий с `DecimalWidget`).
    const draft = useDraftValue(field, toValue, toText);
    return (_jsx(FieldShell, { meta: meta, fieldState: fieldState, label: label, description: description, hint: hint, htmlFor: field.name, children: _jsx(Input, { id: field.name, name: field.name, type: "number", ref: field.ref, onBlur: field.onBlur, onChange: (e) => draft.onChange(e.target.value), value: draft.value, step: step, placeholder: meta.placeholder, readOnly: readonly ?? meta.readonly, disabled: disabled }) }));
}
//# sourceMappingURL=number.js.map